import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "../../../../../_helpers/components/Button";
import { getTeam, getTeamUsers } from "../../../../../_api/Team";
import { InputForm } from "../../../../../_helpers/components/Forms/InputLabel";
import { editTeam, deleteTeam } from "../../../../../_api/Team";
import toast from "react-hot-toast";
import { ColorPicker } from "../../../../../_helpers/components/Forms/ColorPicker";
import { BackButton } from "../../../../../_helpers/components/BackButton";

export const Team = () => {
    const navigate = useNavigate();
    const { team_id } = useParams();

    const [team, setTeam] = useState(null);
    const [teamUsers, setTeamUsers] = useState(null);
    const [colorPickerVisible, setColorPickerVisible] = useState(false);
    const [darkText, setDarkText] = useState(true);
    const [bgColor, setBgColor] = useState("#FFFFFF");
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const changeColors = (color) => {
        setBgColor(color);
        setTeam({ ...team, bg_color: color });
        const r = Number("0x" + color.substring(1, 3));
        const g = Number("0x" + color.substring(3, 5));
        const b = Number("0x" + color.substring(5, 7));
        setDarkText(0.3 * r + 0.59 * g + 0.11 * b >= 128);
    };

    const loadTeam = () => {
        getTeam(team_id).then((resp) => {
            setTeam(resp.data.data);
            setBgColor(resp.data.data.bg_color ?? "#ffffff")
            getTeamUsers(team_id).then((resp) => {
                setTeamUsers(resp.data);
            });
        });
    };

    const _update = () => {
        const payload = {
            name: team.name,
            remarks: team.remarks,
            bg_color: team.bg_color ?? "#ffffff",
            level: team.level ?? 1,
        };

        setIsSaving(true);
        editTeam(team.id, payload)
            .then((resp) => {
                toast(resp.data.message);
                navigate(-1);
            })
            .catch((resp) => {
                toast.error(resp.data.message);
            })
            .finally(() => setIsSaving(false));
    };

    const _delete = () => {
        setIsDeleting(true);
        deleteTeam(team_id)
            .then((resp) => {
                toast(resp.data.message);
                navigate(-1);
            })
            .catch((resp) => {
                toast.error(resp.data.message);
            })
            .finally(() => setIsDeleting(false));
    };

    useEffect(() => {
        loadTeam();
    }, []);

    return (
        <div className="max-w-7xl mx-auto p-4 space-y-6">

            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between flex-wrap gap-4">
                        <div className="flex items-center space-x-4">
                            <BackButton
                                title="Retour"
                            />
                            <div>
                                <h1 className="text-3xl font-bold text-gray-900">
                                    {team_id ? "Modifier" : "Ajouter"} un service / une équipe
                                </h1>
                                <p className="mt-2 text-sm text-gray-600">
                                    {/* {category_id ? "Modifiez" : "Créez"} une catégorie socio-professionnelle */}
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {team_id && (
                                <Button
                                    action={() => _delete()}
                                    type={"red"}
                                    name={"Supprimer"}
                                    loading={isDeleting}
                                />
                            )}
                            <Button
                                action={() => _update()}
                                name={team_id ? "Modifier" : "Ajouter"}
                                loading={isSaving}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-col lg:flex-row w-full lg:w-auto gap-4 lg:items-center justify-between">
                <div className="flex flex-col lg:flex-row gap-x-4">
                    <InputForm
                        name="Nom de l'équipe"
                        type="text"
                        classNameWrapper={"lg:w-64"}
                        required={true}
                        value={team?.name || ""}
                        set={(value) =>
                            setTeam({ ...team, name: value })
                        }
                    >
                    </InputForm>
                    <InputForm
                        name="Niveau"
                        type={"number"}
                        classNameWrapper={"lg:w-32"}
                        min={1}
                        max={9}
                        required={true}
                        value={team?.level || 1}
                        set={(value) =>
                            setTeam({ ...team, level: value })
                        }
                    >
                    </InputForm>
                    <div>
                        <label className="text-left block uppercase tracking-wide text-app-primary text-xs font-bold mb-2">Couleur de fond</label>
                        <div
                            className="h-10 w-40"
                            onMouseLeave={() =>
                                setColorPickerVisible(false)
                            }
                        >
                            <div
                                className="border bg-slate-400 h-10 py-2 px-3 rounded-md"
                                style={{ backgroundColor: bgColor }}
                                onMouseEnter={() =>
                                    setColorPickerVisible(true)
                                }
                                onClick={() =>
                                    setColorPickerVisible(true)
                                }
                            >
                                <div
                                    className={
                                        darkText
                                            ? "text-black/60"
                                            : "text-white/60"
                                    }
                                >
                                    Couleur
                                </div>
                            </div>
                            {colorPickerVisible && (
                                <ColorPicker
                                    setColor={changeColors}
                                    closeModal={() => setColorPickerVisible(false)}
                                    full={false}
                                />
                            )}
                        </div>
                    </div>
                </div>
                {/* <div className="flex-auto flex gap-2 justify-end">
                    <Button
                        type="empty"
                        action={() => navigate(-1)}
                        name="Retour"
                    />
                    <Button
                        action={() => { _update() }}
                        name="Modifier"
                    />
                </div> */}
            </div>

            {team && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Infos équipe */}
                    <div className="bg-white shadow-sm rounded-xl p-6">
                        <h2 className="text-xl font-semibold text-gray-700 mb-2">
                            Informations
                        </h2>
                        <p className="text-gray-600">
                            <strong>Créée le :</strong> {new Date(team.created_at).toLocaleString()}
                        </p>
                        <p className="text-gray-600 mb-4">
                            <strong>Dernière mise à jour :</strong>{" "}
                            {new Date(team.updated_at).toLocaleString()}
                        </p>
                        <InputForm
                            name="Notes"
                            type="textarea"
                            value={team?.remarks || ""}
                            set={(value) =>
                                setTeam({ ...team, remarks: value })
                            }
                            className="appearance-none block w-full bg-gray-100 text-gray-700 border rounded-sm py-2 px-3 leading-tight focus:outline-hidden focus:bg-white focus:border-gray-400"
                        />
                    </div>

                    {/* Participants */}
                    <div className="bg-white shadow-sm rounded-xl p-6">
                        <h2 className="text-xl font-semibold text-gray-700 mb-2">
                            Participants
                        </h2>
                        {teamUsers && teamUsers.length > 0 ? (
                            <ul className="list-disc list-inside text-gray-700">
                                {teamUsers.map((user) => (
                                    <li key={user.id}>
                                        {user.last_name.toUpperCase()}{" "}
                                        {user.first_name}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="text-gray-500">
                                Aucun participant enregistré.
                            </p>
                        )}
                    </div>
                </div>
            )}

            {/* Cumul des heures */}
            <div className="bg-white shadow-sm rounded-xl p-6">
                <h2 className="text-xl font-semibold text-gray-700 mb-2">
                    Cumul des heures
                </h2>
                <ul className="list-disc list-inside text-gray-700">
                    <li>TODO</li>
                </ul>
            </div>
        </div>
    );
};
